export default __webpack_public_path__ + "static/media/awaiting_feedback_activity_course.7e77eb35.svg";